// eslint-disable-next-line no-restricted-imports
import { useBoxClient, useToast } from 'hooks';
import { messages } from 'i18n';

interface UseDownloadFilesProps {
  boxFolderId: string;
}

export default function useDownloadFilesByType({ boxFolderId }: UseDownloadFilesProps) {
  const boxClient = useBoxClient();
  const { showToast } = useToast();

  return async (fileType: string, downloadFileName?: string) => {
    try {
      const filesToDownload = await boxClient.getFilesByFileType(boxFolderId, fileType);
      if (filesToDownload.length === 0) {
        return null;
      }
      return await boxClient.createZip(filesToDownload, downloadFileName);
    } catch (error) {
      showToast('error', { message: messages.general.operationFailed });
      return null;
    }
  };
}
